<template>
  <el-row>
    <el-col>
      <el-menu
        :router="routerMode"
        class="el-menu-vertical-demo full-height"
        background-color="#001529"
        text-color="#e3e3e3"
		active-text-color="#fff"
        :default-active="activeIndex"
        :collapse-transition="true"
        :unique-opened="true"
      >
        <slot name="trademark" />
        <slot name="router" />
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      routerMode: true
    };
  },
  mounted() {
  	console.log(this.activeIndex,90123)
  },
  computed: {
    ...mapState(["activeIndex"])
  }
};
</script>

<style scoped>
.full-height {
  height: 100vh;
}

.el-menu {
  overflow: hidden;
  overflow-y: auto;
}
/deep/ .is-active{
	background-color: #1890ff !important;
}
/deep/ .active{
	color: #fff !important;
}
</style>
